// AUTO-GENERATED by scripts/gen-build-info.js — do not edit.
export const BUILD_INFO = { sha: 'ae9e551b', builtAt: '2026-10-20 18:50 UTC' };
